<mat-nav-list class="left-nav-links">
  @let isCollapsed = isCollapsed$ | async;

  @if (myTodosItem.visible) {
    <a
      [activated]="currentPrimaryPath() === '/' + myTodosItem.route"
      [matTooltip]="isCollapsed ? myTodosItem.label : ''"
      (click)="onNavLinkClick($event, myTodosItem.route)"
      href=""
      mat-list-item
      matTooltipPosition="right"
    >
      <mat-icon matListItemIcon>{{ myTodosItem.icon }}</mat-icon>
      @if (isCollapsed === false) {
        <span matListItemTitle>{{ myTodosItem.label }}</span>
      }
    </a>
  }

  @if (isCollapsed === false) {
    <mat-divider></mat-divider>
  }

  @for (section of navSections; track section.label; let isLast = $last) {
    @if (isCollapsed === false) {
      <h5 mat-subheader>{{ section.label }}</h5>
    }

    @for (item of section.items; track item.route) {
      @if (item.visible) {
        <a
          [activated]="currentPrimaryPath() === '/' + item.route"
          [class.no-margin]="isCollapsed"
          [matTooltip]="isCollapsed ? item.label : ''"
          (click)="onNavLinkClick($event, item.route)"
          href="#"
          mat-list-item
          matTooltipPosition="right"
        >
          <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
          @if (isCollapsed === false) {
            <span matListItemTitle>{{ item.label }}</span>
          }
        </a>
      }
    }

    @if (!isLast && isCollapsed === false) {
      <mat-divider class="no-horizontal-spacing"></mat-divider>
    }
  }
</mat-nav-list>

<button class="toggle-button" (click)="toggleCollapse()" mat-icon-button>
  <mat-icon class="blue">{{ (isCollapsed$ | async) ? 'chevron_right' : 'chevron_left' }}</mat-icon>
</button>
